import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from '@/system/store/mutation-types'

import {
  ISocketState
} from '@/system/socket/store'

import { MutationTree, Mutation } from 'vuex'

const socketOpen: Mutation<ISocketState> = (state: ISocketState) => {
  state.isConnected = true
}

const socketClose: Mutation<ISocketState> = (state: ISocketState, event) => {
  state.isConnected = false
  state.reconnectError = false
}

const socketMessage: Mutation<ISocketState> = (state: ISocketState, message) => {
  state.message = message
}

const socketError: Mutation<ISocketState> = (state: ISocketState, event) => {
  console.error('Socket error', state, event)
  state.isConnected = false
}

const socketReconnect: Mutation<ISocketState> = (state: ISocketState, message) => {
  console.log('socketReconnect')
}

const socketReconnectError: Mutation<ISocketState> = (state: ISocketState) => {
  state.isConnected = false
  state.reconnectError = true
}

const mutations: MutationTree<ISocketState> = {
  [SOCKET_ONOPEN]: socketOpen,
  [SOCKET_ONCLOSE]: socketClose,
  [SOCKET_ONERROR]: socketError,
  [SOCKET_ONMESSAGE]: socketMessage,
  [SOCKET_RECONNECT]: socketReconnect,
  [SOCKET_RECONNECT_ERROR]: socketReconnectError
}

export default mutations
